import Image from "next/image";

const ProactiveCard = ({
  title,
  desc,
  videoSrc = "",
  imgSrc = "",
  isImageRight = true,
  bgColor = "bg-white",
}) => {
  return (
    <div className={`flex flex-col md:flex-row gap-8 md:gap-12  ${bgColor}`}>
      <div
        className={`flex-1 text-start flex flex-col justify-center items-center ${
          bgColor == "bg-dark" ? "text-white" : "text-gray-800"
        } ${isImageRight ? "md:order-1" : "md:order-2"}`}
      >
        <h2 className="text-4xl md:text-5xl font-semibold mb-4 md:mb-8">
          {title}
        </h2>
        <p
          className={`text-lg font-medium ${
            bgColor == "bg-dark" ? "text-white" : "text-gray-600"
          } md:text-2xl md:mb-9`}
        >
          {desc}
        </p>
      </div>
      <div className={` ${isImageRight ? "md:order-2" : "md:order-1"} flex-1`}>
        {videoSrc && (
          <video
            src={videoSrc}
            alt="ai-agent"
            width={500}
            height={500}
            className={`rounded-xl w-full`}
            autoPlay
            loop
            muted
          />
        )}
        {imgSrc && (
          <Image
            src={imgSrc}
            alt="ai-agent"
            width={500}
            height={500}
            className={`rounded-xl  w-full`}
          />
        )}
      </div>
    </div>
  );
};

export default ProactiveCard;
